// ============================================
// HORIZONTAL MOON MAP GENERATOR
// Supports TWO moon canvases side by side
// Each moon has independent date, location, and phase
// ============================================

(function() {
    'use strict';

    // ============================================
    // STATE - Four independent moon states (2 active by default)
    // ============================================
    var moonInstances = {
        1: {
            scene: null,
            camera: null,
            renderer: null,
            moonMesh: null,
            moonGroup: null,
            lights: { ambient: null, directional: null, earthshine: null },
            currentDate: new Date(2020, 4, 10, 21, 0), // May 10, 2020
            currentLocation: { lat: 51.5074, lng: -0.1278, name: 'London, UK' },
            phaseInfo: { phase: 0, illumination: 0, phaseName: '' },
            initialized: false
        },
        2: {
            scene: null,
            camera: null,
            renderer: null,
            moonMesh: null,
            moonGroup: null,
            lights: { ambient: null, directional: null, earthshine: null },
            currentDate: new Date(2025, 5, 19, 21, 0), // June 19, 2025
            currentLocation: { lat: 53.4808, lng: -2.2426, name: 'Manchester, UK' },
            phaseInfo: { phase: 0, illumination: 0, phaseName: '' },
            initialized: false
        },
        3: {
            scene: null,
            camera: null,
            renderer: null,
            moonMesh: null,
            moonGroup: null,
            lights: { ambient: null, directional: null, earthshine: null },
            currentDate: new Date(2024, 0, 1, 21, 0), // Jan 1, 2024
            currentLocation: { lat: 40.7128, lng: -74.0060, name: 'New York, USA' },
            phaseInfo: { phase: 0, illumination: 0, phaseName: '' },
            initialized: false
        },
        4: {
            scene: null,
            camera: null,
            renderer: null,
            moonMesh: null,
            moonGroup: null,
            lights: { ambient: null, directional: null, earthshine: null },
            currentDate: new Date(2024, 0, 1, 21, 0), // Jan 1, 2024
            currentLocation: { lat: 48.8566, lng: 2.3522, name: 'Paris, France' },
            phaseInfo: { phase: 0, illumination: 0, phaseName: '' },
            initialized: false
        }
    };

    // ============================================
    // TEXTURE URLs
    // ============================================
    var MOON_TEXTURES = {
        silver: {
            preview: 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/skylit-studio-moon-texture_8k-web-2.jpg?v=1765117884',
            render: 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/skylit-studio-moon-texture_8k-web-2.jpg?v=1765117884'
        }
    };

    var TEXTURES = {
        moon: MOON_TEXTURES.silver,
        displacement: {
            preview: 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/skylit-studio-moon-texture_8k_displacement-web2.jpg?v=1765117884',
            render: 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/skylit-studio-moon-texture_8k_displacement-web2.jpg?v=1765117884'
        },
        normal: {
            preview: 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/skylit-studio-moon-texture_8k_normal-web-2.jpg?v=1765117884',
            render: 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/skylit-studio-moon-texture_8k_normal-web-2.jpg?v=1765117884'
        }
    };

    // ============================================
    // BRIDGE EXPORTS
    // ============================================
    window.hMoonInstances = moonInstances;

    // ============================================
    // GOOGLE MAPS CALLBACK - Entry Point
    // ============================================
    window.initHMoonMap = function() {
        console.log('🌙 Initializing Horizontal Moon Map (up to 4 moons)...');

        // Setup Google Places Autocomplete for all moons
        setupAutocomplete(1);
        setupAutocomplete(2);
        setupAutocomplete(3);
        setupAutocomplete(4);

        // Initialize date/time selectors for all moons
        initDateTimeSelectors(1);
        initDateTimeSelectors(2);
        initDateTimeSelectors(3);
        initDateTimeSelectors(4);

        // Initialize Three.js for default 2 moons
        initThreeJS(1);
        initThreeJS(2);

        // Load textures for default 2 moons
        loadMoonTextures(1);
        loadMoonTextures(2);

        // Setup UI handlers (including accordion)
        setupUI();

        // Setup accordion for moon sections
        setupAccordion();

        // Store initial template count
        window.hMoonTemplateCount = 2;

        // Handle window resize for responsive moon sizing
        var resizeTimeout;
        $(window).on('resize', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                var count = window.hMoonTemplateCount || 2;
                updateMoonItemSizes(count);
            }, 250);
        });

        // Initial sizing for proper display on page load
        updateMoonItemSizes(2);

        // Apply default font to all text elements on page load
        applyFont('Spectral');

        // Mark generator as fully initialized
        window.hMoonGeneratorReady = true;

        console.log('🌙 Horizontal Moon Map initialized');
    };

    // ============================================
    // ACCORDION FUNCTIONALITY
    // ============================================
    function setupAccordion() {
        // Toggle accordion on header click (supports both old and new card styles)
        $(document).on('click', '.h-moon-section-header, .h-moon-card-header', function() {
            var $header = $(this);
            var moonId = $header.data('accordion-toggle');
            var $content = $('[data-accordion-content="' + moonId + '"]');

            // Toggle collapsed state
            $header.toggleClass('h-collapsed');
            $content.toggleClass('h-collapsed');

            console.log('📁 Moon ' + moonId + ' accordion toggled');
        });
    }

    // ============================================
    // SETUP AUTOCOMPLETE FOR A MOON
    // ============================================
    function setupAutocomplete(moonId) {
        var input = document.getElementById('h-address_form1_moon' + moonId);
        if (!input) return;

        // Bias results towards UK (but don't restrict - customers may want locations worldwide)
        var ukBounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(49.8, -8.6),  // SW corner of UK
            new google.maps.LatLng(60.9, 1.8)    // NE corner of UK
        );

        var autocomplete = new google.maps.places.Autocomplete(input, {
            bounds: ukBounds,
            strictBounds: false  // Allow results outside UK, just prefer UK
        });
        google.maps.event.addListener(autocomplete, 'place_changed', function() {
            var place = autocomplete.getPlace();
            if (place.geometry && place.geometry.location) {
                var instance = moonInstances[moonId];
                instance.currentLocation.lat = place.geometry.location.lat();
                instance.currentLocation.lng = place.geometry.location.lng();
                instance.currentLocation.name = place.formatted_address || place.name || input.value;

                input.value = instance.currentLocation.name;
                $('#h-custom_address_moon' + moonId).val(instance.currentLocation.name);

                // Sync detail edit input with the new location value
                $('#h-custom_location_moon' + moonId).val(instance.currentLocation.name);

                // Trigger change event to update button text
                $(input).trigger('change');

                // Update the canvas display
                $('#h-moon-location-' + moonId).text(instance.currentLocation.name);

                console.log('📍 Moon ' + moonId + ' location changed:', instance.currentLocation.name);
                reloadMoonWithAnimation(moonId);
            }
        });
    }

    // ============================================
    // THREE.JS INITIALIZATION FOR A MOON
    // ============================================
    function initThreeJS(moonId) {
        var canvas = document.getElementById('h-moon-canvas-' + moonId);
        var container = document.getElementById('h-moon-canvas-container-' + moonId);
        if (!canvas || !container) {
            console.error('❌ Canvas or container not found for moon ' + moonId);
            return;
        }

        var instance = moonInstances[moonId];
        var screenWidth = $(window).width();

        // Get size based on screen width (default 2-moon layout)
        var size;
        if (screenWidth <= 480) {
            size = 80;
        } else if (screenWidth <= 768) {
            size = 100;
        } else if (screenWidth <= 834) {
            size = 170;
        } else if (screenWidth <= 1194) {
            size = 150;
        } else {
            size = 210;
        }

        // Scene
        instance.scene = new THREE.Scene();
        instance.scene.background = null; // Transparent background

        // Camera
        instance.camera = new THREE.PerspectiveCamera(0.521, 1, 0.1, 1000);
        instance.camera.position.z = 221;

        // Moon group
        instance.moonGroup = new THREE.Object3D();
        instance.scene.add(instance.moonGroup);

        // Renderer
        instance.renderer = new THREE.WebGLRenderer({
            canvas: canvas,
            antialias: true,
            preserveDrawingBuffer: true,
            alpha: true
        });
        instance.renderer.setSize(size, size);
        instance.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        instance.renderer.outputColorSpace = THREE.SRGBColorSpace;
        instance.renderer.toneMapping = THREE.ACESFilmicToneMapping;
        instance.renderer.toneMappingExposure = 0.80;

        // Lights
        instance.lights.ambient = new THREE.AmbientLight(0x404050, 0.25);
        instance.moonGroup.add(instance.lights.ambient);

        instance.lights.directional = new THREE.DirectionalLight(0xffffff, 3.0);
        instance.lights.directional.position.set(100, 0, 100);
        instance.moonGroup.add(instance.lights.directional);

        instance.lights.earthshine = new THREE.DirectionalLight(0x777788, 1.08);
        instance.lights.earthshine.position.set(-100, 0, -100);
        instance.moonGroup.add(instance.lights.earthshine);

        console.log('🎬 Three.js initialized for moon ' + moonId);
    }

    // ============================================
    // TEXTURE LOADING FOR A MOON
    // ============================================
    function loadMoonTextures(moonId) {
        showLoader();

        var loader = new THREE.TextureLoader();
        var moonUrl = TEXTURES.moon.preview;
        var displacementUrl = TEXTURES.displacement.preview;
        var normalUrl = TEXTURES.normal.preview;

        Promise.all([
            loadTexture(loader, moonUrl, 'Moon ' + moonId),
            loadTexture(loader, displacementUrl, 'Displacement ' + moonId),
            loadTexture(loader, normalUrl, 'Normal ' + moonId)
        ])
        .then(function(textures) {
            createMoon(moonId, textures[0], textures[1], textures[2]);
            hideLoader();
        })
        .catch(function(error) {
            console.error('⚠️ Texture loading error for moon ' + moonId + ':', error);
            loader.load(moonUrl, function(texture) {
                createMoon(moonId, texture, null, null);
                hideLoader();
            });
        });
    }

    function loadTexture(loader, url, name) {
        return new Promise(function(resolve, reject) {
            loader.load(
                url,
                function(texture) {
                    texture.anisotropy = 4;
                    texture.minFilter = THREE.LinearMipmapLinearFilter;
                    texture.magFilter = THREE.LinearFilter;
                    texture.wrapS = THREE.RepeatWrapping;
                    texture.wrapT = THREE.RepeatWrapping;
                    resolve(texture);
                },
                undefined,
                function(error) {
                    console.warn('⚠️ Failed to load:', name);
                    resolve(null);
                }
            );
        });
    }

    // ============================================
    // MOON CREATION
    // ============================================
    function createMoon(moonId, moonTexture, displacementTexture, normalTexture) {
        var instance = moonInstances[moonId];
        var geometry = new THREE.SphereGeometry(1, 256, 256);

        var materialConfig = {
            color: 0xf5f5f5,
            map: moonTexture,
            roughness: 0.95,
            metalness: 0.0,
            envMapIntensity: 0.1
        };

        if (displacementTexture) {
            materialConfig.displacementMap = displacementTexture;
            materialConfig.displacementScale = 0.02;
        }

        if (normalTexture) {
            materialConfig.normalMap = normalTexture;
            materialConfig.normalScale = new THREE.Vector2(1.0, 1.0);
        }

        var material = new THREE.MeshStandardMaterial(materialConfig);
        instance.moonMesh = new THREE.Mesh(geometry, material);
        instance.moonGroup.add(instance.moonMesh);
        instance.moonMesh.rotation.y = -THREE.MathUtils.degToRad(90);

        updateMoon(moonId);
        render(moonId);
    }

    // ============================================
    // MOON PHASE UPDATE
    // ============================================
    function updateMoon(moonId) {
        var instance = moonInstances[moonId];
        if (!instance.moonMesh) return;

        var moonIllum = SunCalc.getMoonIllumination(instance.currentDate);
        var phaseName = getPhaseName(moonIllum.phase);
        var illuminationPercent = Math.round(moonIllum.fraction * 100);

        instance.phaseInfo = {
            phase: moonIllum.phase,
            illumination: illuminationPercent,
            phaseName: phaseName
        };

        console.log('🌙 Moon ' + moonId + ' Phase:', phaseName, '| Illumination:', illuminationPercent + '%');

        applyMoonTransforms(moonId, moonIllum, phaseName, illuminationPercent);
    }

    function applyMoonTransforms(moonId, moonIllum, phaseName, illuminationPercent) {
        var instance = moonInstances[moonId];
        var positionAngle = computeAxisPositionAngle(instance.currentDate);
        var brightLimb = computeBrightLimbAngle(instance.currentDate);

        // Libration
        var libration = { elon: 0, elat: 0 };
        if (typeof Astronomy !== 'undefined' && Astronomy.Libration) {
            try {
                libration = Astronomy.Libration(instance.currentDate);
            } catch(e) {
                console.warn('⚠️ Libration calculation failed for moon ' + moonId);
            }
        }

        // Parallactic angle
        var parallacticAngle = 0;
        if (typeof Astronomy !== 'undefined') {
            try {
                parallacticAngle = calculateParallacticAngle(instance.currentDate, instance.currentLocation.lat, instance.currentLocation.lng);
            } catch(e) {
                parallacticAngle = 0;
            }
        }

        // Reset rotations
        instance.moonMesh.rotation.x = 0;
        instance.moonMesh.rotation.y = -THREE.MathUtils.degToRad(90);
        instance.moonMesh.rotation.z = 0;
        instance.moonGroup.rotation.set(0, 0, 0);

        // Apply transforms
        var xAxis = new THREE.Vector3(1, 0, 0);
        var yAxis = new THREE.Vector3(0, 1, 0);
        var zAxis = new THREE.Vector3(0, 0, 1);

        var lonLibration = THREE.MathUtils.degToRad(libration.elon);
        var latLibration = THREE.MathUtils.degToRad(libration.elat);

        instance.moonMesh.rotateOnWorldAxis(yAxis, -lonLibration);
        instance.moonMesh.rotateOnWorldAxis(xAxis, latLibration);
        instance.moonMesh.rotateOnWorldAxis(zAxis, positionAngle);
        instance.moonGroup.rotation.z = -parallacticAngle;

        // Update lighting
        updateLightingForPhase(moonId, moonIllum, brightLimb);

        // Update UI
        updatePhaseDisplay(moonId, phaseName, illuminationPercent);

        render(moonId);
    }

    // ============================================
    // LIGHTING UPDATE
    // ============================================
    function updateLightingForPhase(moonId, moonIllum, brightLimb) {
        var instance = moonInstances[moonId];
        var fraction = moonIllum.fraction;

        var F = Math.PI / 2 - brightLimb;
        var C = Math.acos(1 - 2 * fraction);

        var lightX = -Math.sin(C) * Math.cos(F);
        var lightY = Math.sin(C) * Math.sin(F);
        var lightZ = -Math.cos(C);

        instance.lights.directional.position.set(lightX * 100, lightY * 100, lightZ * 100);
        instance.lights.earthshine.position.set(-lightX * 100, -lightY * 100, -lightZ * 100);

        if (fraction < 0.25) {
            instance.lights.ambient.intensity = 0.35;
            instance.lights.directional.intensity = 2.6;
        } else if (fraction < 0.5) {
            instance.lights.ambient.intensity = 0.3;
            instance.lights.directional.intensity = 2.8;
        } else {
            instance.lights.ambient.intensity = 0.25;
            instance.lights.directional.intensity = 2.4;
        }
    }

    // ============================================
    // ASTRONOMY CALCULATIONS
    // ============================================
    function deg2rad(d) {
        return d * Math.PI / 180;
    }

    function computeBrightLimbAngle(date) {
        var observer = new Astronomy.Observer(0, 0, 0);
        var moonEqu = Astronomy.Equator('Moon', date, observer, true, true);
        var sunEqu = Astronomy.Equator('Sun', date, observer, true, true);

        var alpha = deg2rad(moonEqu.ra * 15);
        var delta = deg2rad(moonEqu.dec);
        var alpha0 = deg2rad(sunEqu.ra * 15);
        var delta0 = deg2rad(sunEqu.dec);

        var num = Math.cos(delta0) * Math.sin(alpha0 - alpha);
        var den = Math.sin(delta0) * Math.cos(delta) - Math.cos(delta0) * Math.sin(delta) * Math.cos(alpha0 - alpha);

        return Math.atan2(num, den);
    }

    function computeAxisPositionAngle(date) {
        var RA_P = deg2rad(269.9949);
        var DEC_P = deg2rad(66.5392);

        var observer = new Astronomy.Observer(0, 0, 0);
        var moonEqu = Astronomy.Equator('Moon', date, observer, true, true);

        var alpha = deg2rad(moonEqu.ra * 15);
        var delta = deg2rad(moonEqu.dec);

        var num = Math.cos(DEC_P) * Math.sin(RA_P - alpha);
        var den = Math.sin(DEC_P) * Math.cos(delta) - Math.cos(DEC_P) * Math.sin(delta) * Math.cos(RA_P - alpha);

        return Math.atan2(num, den);
    }

    function calculateParallacticAngle(date, lat, lng) {
        var observer = new Astronomy.Observer(lat, lng, 0);
        var equ = Astronomy.Equator('Moon', date, observer, true, true);
        var gast = Astronomy.SiderealTime(date);
        var hourAngle = (gast + lng / 15 - equ.ra) * 15;
        hourAngle = THREE.MathUtils.degToRad(hourAngle);

        var latRad = THREE.MathUtils.degToRad(lat);
        var decRad = THREE.MathUtils.degToRad(equ.dec);

        var sinQ = Math.sin(hourAngle) * Math.cos(latRad);
        var cosQ = Math.sin(latRad) * Math.cos(decRad) - Math.cos(latRad) * Math.sin(decRad) * Math.cos(hourAngle);

        return Math.atan2(sinQ, cosQ);
    }

    // ============================================
    // PHASE NAME HELPER
    // ============================================
    function getPhaseName(phase) {
        if (phase < 0.025 || phase > 0.975) return 'New Moon';
        if (phase < 0.225) return 'Waxing Crescent';
        if (phase < 0.275) return 'First Quarter';
        if (phase < 0.475) return 'Waxing Gibbous';
        if (phase < 0.525) return 'Full Moon';
        if (phase < 0.725) return 'Waning Gibbous';
        if (phase < 0.775) return 'Last Quarter';
        return 'Waning Crescent';
    }

    // ============================================
    // RENDER
    // ============================================
    function render(moonId) {
        var instance = moonInstances[moonId];
        if (instance.renderer && instance.scene && instance.camera) {
            instance.renderer.render(instance.scene, instance.camera);
        }
    }

    // ============================================
    // DATE/TIME SELECTORS FOR A MOON
    // ============================================
    function initDateTimeSelectors(moonId) {
        var instance = moonInstances[moonId];
        var defaultDate = instance.currentDate;

        // Populate Days
        var daysHtml = '';
        for (var d = 1; d <= 31; d++) {
            var selected = (d === defaultDate.getDate()) ? 'selected' : '';
            daysHtml += '<option value="' + d + '" ' + selected + '>' + d + '</option>';
        }
        $('.h-bear-dates[data-moon="' + moonId + '"]').html(daysHtml);

        // Populate Months
        var monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                          'July', 'August', 'September', 'October', 'November', 'December'];
        var monthsHtml = '';
        for (var m = 0; m < 12; m++) {
            var selected = (m === defaultDate.getMonth()) ? 'selected' : '';
            monthsHtml += '<option value="' + m + '" ' + selected + '>' + monthNames[m] + '</option>';
        }
        $('.h-bear-months[data-moon="' + moonId + '"]').html(monthsHtml);

        // Populate Years
        var yearsHtml = '';
        for (var y = 1920; y <= 2035; y++) {
            var selected = (y === defaultDate.getFullYear()) ? 'selected' : '';
            yearsHtml += '<option value="' + y + '" ' + selected + '>' + y + '</option>';
        }
        $('.h-bear-years[data-moon="' + moonId + '"]').html(yearsHtml);

        // Populate Hours
        var hoursHtml = '';
        for (var h = 0; h <= 23; h++) {
            var displayHour = h.toString().padStart(2, '0');
            var selected = (h === 21) ? 'selected' : '';
            hoursHtml += '<option value="' + h + '" ' + selected + '>' + displayHour + '</option>';
        }
        $('.h-moon-hours[data-moon="' + moonId + '"]').html(hoursHtml);

        // Populate Minutes
        var minutesHtml = '';
        for (var min = 0; min <= 59; min++) {
            var displayMin = min.toString().padStart(2, '0');
            var selected = (min === 0) ? 'selected' : '';
            minutesHtml += '<option value="' + min + '" ' + selected + '>' + displayMin + '</option>';
        }
        $('.h-moon-minutes[data-moon="' + moonId + '"]').html(minutesHtml);

        // Change handlers
        $('.h-bear-dates[data-moon="' + moonId + '"], .h-bear-months[data-moon="' + moonId + '"], .h-bear-years[data-moon="' + moonId + '"], .h-moon-hours[data-moon="' + moonId + '"], .h-moon-minutes[data-moon="' + moonId + '"]').on('change', function() {
            var mid = $(this).data('moon');
            updateDateFromSelectors(mid);
            reloadMoonWithAnimation(mid);
        });

        // Initial update
        updateDateFromSelectors(moonId);
        updateDateDisplay(moonId);
    }

    function updateDateFromSelectors(moonId) {
        var day = parseInt($('.h-bear-dates[data-moon="' + moonId + '"]').val()) || 1;
        var month = parseInt($('.h-bear-months[data-moon="' + moonId + '"]').val()) || 0;
        var year = parseInt($('.h-bear-years[data-moon="' + moonId + '"]').val()) || new Date().getFullYear();
        var hoursVal = parseInt($('.h-moon-hours[data-moon="' + moonId + '"]').val());
        var hours = isNaN(hoursVal) ? 21 : hoursVal;
        var minutesVal = parseInt($('.h-moon-minutes[data-moon="' + moonId + '"]').val());
        var minutes = isNaN(minutesVal) ? 0 : minutesVal;

        moonInstances[moonId].currentDate = new Date(year, month, day, hours, minutes);
        console.log('📅 Moon ' + moonId + ' date updated:', moonInstances[moonId].currentDate.toLocaleString());

        updateDateDisplay(moonId);
    }

    // ============================================
    // DISPLAY UPDATES
    // ============================================
    function updatePhaseDisplay(moonId, phaseName, illuminationPercent) {
        // Phase display removed per user request
        // Keeping function for backward compatibility but not updating UI
    }

    function updateDateDisplay(moonId) {
        var instance = moonInstances[moonId];
        var date = instance.currentDate;

        var day = date.getDate();
        var month = date.getMonth();
        var year = date.getFullYear();

        // Format as ordinal date: "1st May, 2025"
        var ordinalSuffix = getOrdinalSuffix(day);
        var monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                          'July', 'August', 'September', 'October', 'November', 'December'];
        var dateStr = day + ordinalSuffix + ' ' + monthNames[month] + ', ' + year;

        // Always update the hidden field for form submission
        $('#h-auto_date_moon' + moonId).val(dateStr);

        // Sync detail edit input with the new date value
        $('#h-custom_date_moon' + moonId).val(dateStr);

        // Update the canvas display
        $('#h-moon-date-' + moonId).text(dateStr);
    }

    // Helper function to get ordinal suffix (1st, 2nd, 3rd, etc.)
    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }

    // ============================================
    // LOADING ANIMATION (CSS-only loader - no external scripts)
    // ============================================
    function showLoader() {
        $('.myloader').fadeIn(200);
    }

    function hideLoader() {
        $('.myloader').fadeOut(300);
    }

    function reloadMoonWithAnimation(moonId) {
        showLoader();
        setTimeout(function() {
            updateMoon(moonId);
            hideLoader();
        }, 100);
    }

    // ============================================
    // UI SETUP
    // ============================================
    function setupUI() {
        // Text input handlers
        $('#h-textTitle').on('input', function() {
            var title = $(this).val() || 'The Fentons';
            $('#h-skyMap-title').text(title);
        });

        $('#h-textSubtitle').on('input', function() {
            var subtitle = $(this).val() || 'Our Timeline In The Sky';
            $('#h-skyMap-subtitle').text(subtitle);
        });

        $('#h-moon1Name').on('input', function() {
            var name = $(this).val() || 'We Met';
            $('#h-moon-name-1').text(name);
        });

        $('#h-moon2Name').on('input', function() {
            var name = $(this).val() || 'We Married';
            $('#h-moon-name-2').text(name);
        });

        // Mobile tabs
        $('.h-mobile__menu li').on('click', function(e) {
            e.preventDefault();
            var idx = $(this).index();
            $('.h-mobile__menu li').removeClass('h-active__mobile');
            $(this).addClass('h-active__mobile');

            $('.h-element__settings').removeClass('h-active__settings');
            $('.h-content__settings').hide();
            $('.h-element__settings').eq(idx).addClass('h-active__settings h-visited').find('.h-content__settings').show();

            if (idx === 3) {
                $('.h-next__step').hide();
                $('.h-submit__form').addClass('h-show-submit').show();
            } else {
                $('.h-next__step').show();
                $('.h-submit__form').removeClass('h-show-submit').hide();
            }
        });

        // Next step button
        $('.h-next__step').on('click', function(e) {
            e.preventDefault();
            var currentIdx = $('.h-element__settings.h-active__settings').index();
            if (currentIdx < 3) {
                $('.h-element__settings').eq(currentIdx)
                    .addClass('h-visited')
                    .removeClass('h-active__settings')
                    .find('.h-content__settings').slideUp(300);

                $('.h-element__settings').eq(currentIdx + 1)
                    .addClass('h-active__settings h-visited')
                    .find('.h-content__settings').slideDown(300);

                $('.h-mobile__menu li').removeClass('h-active__mobile').eq(currentIdx + 1).addClass('h-active__mobile');

                if (currentIdx + 1 === 3) {
                    $('.h-next__step').hide();
                    $('.h-submit__form').addClass('h-show-submit').show();
                }
            }
        });

        // Product type toggle
        $('.h-orientation_picker').on('click', '.h-elem__picker', function() {
            $('.h-orientation_picker .h-elem__picker').removeClass('h-active__picker');
            $(this).addClass('h-active__picker');

            var state = $(this).data('state');
            $('.h-final__step').hide();
            $('.h-final__step[data-state="' + state + '"]').show();

            if (state === 'H-Framed__picker') {
                var activeFrame = $('.h-frame_picker .h-active__picker').data('frame') || 'Black';
                applyFrameStyle(activeFrame);
            } else {
                $('.h-custom-frame').removeClass('frame-black frame-white frame-natural').addClass('frame-none');
            }
        });

        // Frame style picker
        $('.h-frame_picker').on('click', '.h-elem__picker', function() {
            $('.h-frame_picker .h-elem__picker').removeClass('h-active__picker');
            $(this).addClass('h-active__picker');
            var frameType = $(this).data('frame');
            applyFrameStyle(frameType);
        });

        // Size pickers
        $('.h-size_picker, .h-size_picker_framed').on('click', '.h-elem__picker', function() {
            $(this).closest('.h-grid__picker').find('.h-elem__picker').removeClass('h-active__picker');
            $(this).addClass('h-active__picker');
        });

        // Template selector (2/3/4 moons)
        $('.h-template-picker').on('click', '.h-template-option', function() {
            $('.h-template-option').removeClass('h-active__picker');
            $(this).addClass('h-active__picker');

            var templateCount = parseInt($(this).data('template'));
            updateTemplateLayout(templateCount);
        });

        // Background picker
        $('.h-background-picker').on('click', '.h-background-option', function() {
            $('.h-background-option').removeClass('h-active__picker');
            $(this).addClass('h-active__picker');

            var bgKey = $(this).data('bg');
            applyBackground(bgKey);
        });

        // Font selector
        $('.h-font-picker').on('click', '.h-font-option', function() {
            $('.h-font-option').removeClass('h-active__picker');
            $(this).addClass('h-active__picker');

            var fontFamily = $(this).data('font');
            applyFont(fontFamily);
        });

        // Moon 3 label input handler
        $('#h-moon3Name').on('input', function() {
            var name = $(this).val() || 'Moon 3';
            $('#h-moon-name-3').text(name);
        });

        // Moon 4 label input handler
        $('#h-moon4Name').on('input', function() {
            var name = $(this).val() || 'Moon 4';
            $('#h-moon-name-4').text(name);
        });

        // Initialize UI state
        $('.h-element__settings').first().addClass('h-active__settings h-visited').find('.h-content__settings').show();
        $('.h-element__settings').not(':first').find('.h-content__settings').hide();

        // ============================================
        // Optional Detail Edits Handlers
        // ============================================
        setupDetailEdits();

        // ============================================
        // STEP 4: Dynamic Product Options Handlers
        // ============================================
        initProductOptions();

        console.log('🎨 H-Moon UI initialized');
    }

    // ============================================
    // OPTIONAL DETAIL EDITS HANDLERS
    // ============================================
    function setupDetailEdits() {
        // Accordion toggle is now handled by moon section accordion handler
        // (uses same .h-moon-section-header pattern with data-accordion-toggle)

        // Custom Date Text input handlers (for all 4 moons)
        for (var i = 1; i <= 4; i++) {
            (function(moonId) {
                $('#h-custom_date_moon' + moonId).on('input', function() {
                    var customDate = $(this).val();
                    // Update canvas display with whatever the user types
                    $('#h-moon-date-' + moonId).text(customDate);
                });

                // Custom Location Text input handlers
                $('#h-custom_location_moon' + moonId).on('input', function() {
                    var customLocation = $(this).val();
                    // Update canvas display with whatever the user types
                    $('#h-moon-location-' + moonId).text(customLocation);
                });
            })(i);
        }

        // Initial sync of detail edit fields with current values
        syncDetailEditsWithCurrentValues();

        console.log('✏️ Detail Edits handlers initialized');
    }

    // Sync detail edit inputs with current location/date values
    function syncDetailEditsWithCurrentValues() {
        for (var i = 1; i <= 4; i++) {
            syncDetailEditForMoon(i);
        }
    }

    // Sync a single moon's detail edit fields
    function syncDetailEditForMoon(moonId) {
        // Sync date - set as actual value
        var dateText = $('#h-moon-date-' + moonId).text();
        if (dateText) {
            $('#h-custom_date_moon' + moonId).val(dateText);
            $('#h-auto_date_moon' + moonId).val(dateText);
        }

        // Sync location - set as actual value
        var locationText = $('#h-moon-location-' + moonId).text();
        if (locationText) {
            $('#h-custom_location_moon' + moonId).val(locationText);
        }
    }

    // Export for use in other functions
    window.syncDetailEditForMoon = syncDetailEditForMoon;

    // ============================================
    // PRODUCT OPTIONS (Step 4 - Dynamic Liquid)
    // ============================================
    function initProductOptions() {
        // Product Type (Option 1) - state_1 pickers
        $('.h-orientation_picker').on('click', '.h-elem__state', function() {
            var $this = $(this);
            if ($this.hasClass('h-sold-out')) return;

            // Remove active from siblings
            $('.h-orientation_picker .h-elem__state').removeClass('h-active__picker');
            $this.addClass('h-active__picker');

            var state = $this.data('state');
            var option = $this.data('option');

            // Hide all state pickers
            $('.h-state__picker').hide().removeClass('h-show');

            // Show matching state pickers (frame color and size for this product type)
            $('.h-state__picker[data-state="' + state + '"]').show().addClass('h-show');

            // Auto-select first option in each visible picker
            $('.h-state__picker.h-show').each(function() {
                var $picker = $(this);
                if (!$picker.find('.h-active__picker').length) {
                    $picker.find('.h-elem__picker').first().addClass('h-active__picker');
                }
            });

            // Apply frame style if framed product selected
            if (option && (option.toLowerCase().includes('framed') || option.toLowerCase().includes('black') ||
                option.toLowerCase().includes('white') || option.toLowerCase().includes('natural'))) {
                var frameColor = $('.h-frame_picker .h-active__picker').data('option') || 'Black';
                applyFrameStyle(frameColor);
            } else {
                $('.h-custom-frame').removeClass('frame-black frame-white frame-natural').addClass('frame-none');
            }

            updateVariantSelection();
            console.log('📦 Product type selected:', option);
        });

        // Frame Color (Option 3) picker
        $('.h-frame_picker').on('click', '.h-elem__picker', function() {
            var $this = $(this);
            $('.h-frame_picker .h-elem__picker').removeClass('h-active__picker');
            $this.addClass('h-active__picker');

            var frameColor = $this.data('option');
            applyFrameStyle(frameColor);
            updateVariantSelection();
            console.log('🖼️ Frame color selected:', frameColor);
        });

        // Size (Option 2) picker
        $('.h-size_picker').on('click', '.h-elem__picker', function() {
            var $this = $(this);
            if ($this.hasClass('h-sold-out')) return;

            $(this).closest('.h-grid__picker').find('.h-elem__picker').removeClass('h-active__picker');
            $this.addClass('h-active__picker');

            updateVariantSelection();
            console.log('📐 Size selected:', $this.data('option'));
        });

        // Gift Options picker
        $('.h-gift_picker').on('click', '.h-elem__picker', function() {
            $('.h-gift_picker .h-elem__picker').removeClass('h-active__picker');
            $(this).addClass('h-active__picker');

            var giftOption = $(this).data('dropdown');
            window.hMoonGiftOption = giftOption;
            console.log('🎁 Gift option selected:', giftOption);
        });

        // Initialize first product type as active
        setTimeout(function() {
            var $firstProduct = $('.h-orientation_picker .h-elem__state').first();
            if (!$firstProduct.hasClass('h-active__picker')) {
                $firstProduct.trigger('click');
            }
        }, 100);
    }

    // Update variant selection based on all picker choices
    function updateVariantSelection() {
        var productType = $('.h-orientation_picker .h-elem__state.h-active__picker').data('option') || '';

        // Get size from the VISIBLE/ACTIVE size picker only (each product type has its own)
        var size = $('.h-state__picker.h-show .h-size_picker .h-elem__picker.h-active__picker').data('option') || '';

        // Only get frame color if the current product type has frame color picker visible
        var frameColor = '';
        var productTypeLower = productType.toLowerCase();
        var hasFrameColor = productTypeLower.includes('framed') ||
                           productTypeLower.includes('black') ||
                           productTypeLower.includes('white') ||
                           productTypeLower.includes('natural');

        if (hasFrameColor) {
            frameColor = $('.h-state__picker.h-show .h-frame_picker .h-elem__picker.h-active__picker').data('option') || '';
        }

        // Find matching variant
        var $select = $('#h-product-select');
        var found = false;

        console.log('🔍 Searching for variant - Product:', productType, 'Frame:', frameColor, 'Size:', size);

        $select.find('option').each(function() {
            var $opt = $(this);
            var title = $opt.text().toLowerCase();

            var matchProduct = !productType || title.includes(productType.toLowerCase());
            var matchFrame = !frameColor || title.includes(frameColor.toLowerCase());
            var matchSize = !size || title.includes(size.toLowerCase());

            if (matchProduct && matchFrame && matchSize) {
                $opt.prop('selected', true);
                $('#h-var_id').val($opt.val());

                // Update price display
                var priceMatch = $opt.text().match(/[£$€][\d,.]+/);
                if (priceMatch) {
                    $('.h-add__cart--price p').text(priceMatch[0]);
                    console.log('✅ Price updated to:', priceMatch[0]);
                } else {
                    console.log('⚠️ No price found in variant text:', $opt.text());
                }
                found = true;
                console.log('✅ Variant found:', $opt.text());
                return false;
            }
        });

        if (!found) {
            console.log('❌ No matching variant found! Falling back to first available.');
            // Fallback to first available variant
            var $firstAvailable = $select.find('option').first();
            $firstAvailable.prop('selected', true);
            $('#h-var_id').val($firstAvailable.val());

            // Update price display for fallback
            var priceMatch = $firstAvailable.text().match(/[£$€][\d,.]+/);
            if (priceMatch) {
                $('.h-add__cart--price p').text(priceMatch[0]);
            }
        }
    }

    // ============================================
    // TEMPLATE LAYOUT (2/3/4 moons)
    // ============================================
    function updateTemplateLayout(count) {
        console.log('🌙 Template changed to ' + count + ' moons');

        // Update CSS class on container for layout
        var $container = $('#h-moons-container');
        $container.removeClass('h-layout-2 h-layout-3 h-layout-4');
        $container.addClass('h-layout-' + count);

        // Show/hide moon 3 in sidebar, preview, and detail edits
        if (count >= 3) {
            $('.h-moon-3-section').show();
            $('.h-moon-3-label').show();
            $('.h-moon-3-preview').show();
            $('.h-detail-edit-moon3').show();

            // Initialize moon 3 if not already done
            if (!moonInstances[3].initialized) {
                initThreeJS(3);
                loadMoonTextures(3);
                moonInstances[3].initialized = true;
            }
        } else {
            $('.h-moon-3-section').hide();
            $('.h-moon-3-label').hide();
            $('.h-moon-3-preview').hide();
            $('.h-detail-edit-moon3').hide();
        }

        // Show/hide moon 4 in sidebar, preview, and detail edits
        if (count >= 4) {
            $('.h-moon-4-section').show();
            $('.h-moon-4-label').show();
            $('.h-moon-4-preview').show();
            $('.h-detail-edit-moon4').show();

            // Initialize moon 4 if not already done
            if (!moonInstances[4].initialized) {
                initThreeJS(4);
                loadMoonTextures(4);
                moonInstances[4].initialized = true;
            }
        } else {
            $('.h-moon-4-section').hide();
            $('.h-moon-4-label').hide();
            $('.h-moon-4-preview').hide();
            $('.h-detail-edit-moon4').hide();
        }

        // Store template count for form submission
        window.hMoonTemplateCount = count;

        // Update moon item sizes based on layout
        updateMoonItemSizes(count);
    }

    // ============================================
    // UPDATE MOON ITEM SIZES FOR LAYOUT
    // ============================================
    function updateMoonItemSizes(count) {
        var $items = $('#h-moons-container .h-moon-item');

        // Reset all items first
        $items.css({
            'max-width': '',
            'flex': ''
        });

        // Get canvas size based on layout and screen width
        var screenWidth = $(window).width();
        var canvasSize = 210; // Default for 2 moons on desktop

        if (count === 2) {
            $items.css({
                'max-width': '45%',
                'flex': '1'
            });
            // Size based on screen width
            if (screenWidth <= 480) {
                canvasSize = 80;
            } else if (screenWidth <= 768) {
                canvasSize = 100;
            } else if (screenWidth <= 834) {
                canvasSize = 170;
            } else if (screenWidth <= 1194) {
                canvasSize = 160;
            } else {
                canvasSize = 210;
            }
        } else if (count === 3) {
            $items.css({
                'max-width': '30%',
                'flex': '1'
            });
            if (screenWidth <= 480) {
                canvasSize = 65;
            } else if (screenWidth <= 768) {
                canvasSize = 75;
            } else if (screenWidth <= 834) {
                canvasSize = 170;
            } else if (screenWidth <= 1194) {
                canvasSize = 190;
            } else {
                canvasSize = 140;
            }
        } else if (count === 4) {
            $items.css({
                'max-width': '22%',
                'flex': '1'
            });
            if (screenWidth <= 480) {
                canvasSize = 50;
            } else if (screenWidth <= 768) {
                canvasSize = 60;
            } else if (screenWidth <= 834) {
                canvasSize = 130;
            } else if (screenWidth <= 1194) {
                canvasSize = 130;
            } else {
                canvasSize = 110;
            }
        }

        // Resize all active moon renderers to maintain 1:1 ratio
        for (var i = 1; i <= count; i++) {
            resizeMoonRenderer(i, canvasSize);
        }
    }

    // ============================================
    // RESIZE MOON RENDERER
    // ============================================
    function resizeMoonRenderer(moonId, size) {
        var instance = moonInstances[moonId];
        if (instance && instance.renderer) {
            instance.renderer.setSize(size, size);
            render(moonId);
        }
    }

    // ============================================
    // BACKGROUND SWITCHER
    // ============================================
    var BACKGROUNDS = {
        'family3': 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/skylit-studio-personalised-moon-phases-family-background3.webp?v=1765254076',
        'family1': 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/skylit-studio-galaxy-background-render-cleaner.webp?v=1765303138',
        'family2': 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/skylit-studio-skylit-studio-starry-night-sky-shooting-star-wallpaper.webp?v=1765303702',
        'black': 'https://cdn.shopify.com/s/files/1/0710/5278/7987/files/skylit-studio-skylit-studio-black-wallpaper.webp?v=1765303906'
    };

    function applyBackground(bgKey) {
        var bgUrl = BACKGROUNDS[bgKey] || BACKGROUNDS['family3'];
        $('.h-custom-frame').css('background-image', 'url(' + bgUrl + ')');
        console.log('🖼️ Background changed to:', bgKey);

        // Store for form submission
        window.hMoonBackground = bgKey;
    }

    // ============================================
    // FONT SWITCHER
    // ============================================
    var FONT_MAP = {
        'Spectral': "'Spectral', serif",
        'Poppins': "'Poppins', sans-serif",
        'Prata': "'Prata', serif",
        'Dancing Script': "'Dancing Script', cursive",
        'Caveat': "'Caveat', cursive",
        'Kaushan Script': "'Kaushan Script', cursive",
        'Righteous': "'Righteous', cursive",
        'IM Fell English SC': "'IM Fell English SC', serif",
        'Fredericka the Great': "'Fredericka the Great', cursive"
    };

    function applyFont(fontName) {
        var fontFamily = FONT_MAP[fontName] || FONT_MAP['Spectral'];

        // Apply to ALL text elements (title, subtitle, moon names, dates, and locations)
        $('#h-skyMap-title').css('font-family', fontFamily);
        $('#h-skyMap-subtitle').css('font-family', fontFamily);
        $('.h-moon-name-text').css('font-family', fontFamily);
        $('.h-moon-date-text').css('font-family', fontFamily);
        $('.h-moon-location-text').css('font-family', fontFamily);

        console.log('🔤 Font changed to:', fontName);

        // Store for form submission
        window.hMoonFont = fontName;
    }

    function applyFrameStyle(frameType) {
        var $frame = $('.h-custom-frame');
        $frame.removeClass('frame-none frame-black frame-white frame-natural');

        if (frameType === 'Black') {
            $frame.addClass('frame-black');
        } else if (frameType === 'White') {
            $frame.addClass('frame-white');
        } else if (frameType === 'Natural') {
            $frame.addClass('frame-natural');
        }
    }

    // ============================================
    // EXPORT FUNCTIONS
    // ============================================
    window.exportHMoonCanvas = function(moonId, width, height) {
        var instance = moonInstances[moonId];
        if (!instance || !instance.renderer) {
            console.warn('⚠️ Moon ' + moonId + ' renderer not available for export');
            return '';
        }

        try {
            // Detect mobile and adjust export size to prevent memory issues
            var isMobile = window.innerWidth <= 768;
            var exportWidth = width || (isMobile ? 256 : 512);
            var exportHeight = height || (isMobile ? 256 : 512);

            // Store original settings
            var originalSize = instance.renderer.getSize(new THREE.Vector2());
            var originalPixelRatio = instance.renderer.getPixelRatio();

            // Reset pixel ratio to 1 for consistent export size
            // This prevents mobile high-DPI screens from creating oversized buffers
            instance.renderer.setPixelRatio(1);
            instance.renderer.setSize(exportWidth, exportHeight);
            render(moonId);

            // Capture the canvas data
            var dataURL = '';
            try {
                dataURL = instance.renderer.domElement.toDataURL('image/jpeg', 0.85);
            } catch (canvasError) {
                console.warn('⚠️ Canvas toDataURL failed for moon ' + moonId + ':', canvasError.message);
                // Try with lower quality as fallback
                try {
                    dataURL = instance.renderer.domElement.toDataURL('image/jpeg', 0.5);
                } catch (fallbackError) {
                    console.warn('⚠️ Fallback canvas export also failed for moon ' + moonId);
                    dataURL = '';
                }
            }

            // Restore original settings
            instance.renderer.setPixelRatio(originalPixelRatio);
            instance.renderer.setSize(originalSize.x, originalSize.y);
            render(moonId);

            return dataURL;
        } catch (error) {
            console.error('❌ Export failed for moon ' + moonId + ':', error.message);
            return '';
        }
    };

    window.updateHMoon = function(moonId) {
        reloadMoonWithAnimation(moonId);
    };

    // Update moon from selector values and reload - used by scroll pickers
    window.updateHMoonFromSelectors = function(moonId) {
        updateDateFromSelectors(moonId);
        reloadMoonWithAnimation(moonId);
    };

    window.getHMoonData = function(moonId) {
        var instance = moonInstances[moonId];
        return {
            date: instance.currentDate,
            location: instance.currentLocation,
            phaseInfo: instance.phaseInfo
        };
    };

    // Expose updateTemplateLayout for external use (e.g., order reload)
    window.updateHMoonTemplateLayout = function(count) {
        updateTemplateLayout(count);
    };

})();
